import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    if (error.response?.status === 401 && !original._retry && !String(original.url).includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Terjadi kesalahan. Silakan coba lagi.") {
  const detail = e?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const rupiah = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export const formatDate = (v, opts = { day: "numeric", month: "long", year: "numeric" }) =>
  v ? new Date(v).toLocaleDateString("id-ID", opts) : "-";

export const formatTime = (v) =>
  v ? new Date(v).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" }) : "";

export const homeFor = (user) => {
  if (!user) return "/";
  if (!user.role) return "/pilih-peran";
  if (user.role === "penyedia") return "/dasbor/permintaan-masuk";
  if (user.role === "pelanggan") return "/permintaan-saya";
  if (user.role === "admin") return "/admin";
  return "/";
};
